// eslint-disable-next-line no-unused-vars
export default defineNuxtRouteMiddleware((to, from) => {
    // Set return route on every route change
    const {$returnRoute} = useNuxtApp();
    if ($returnRoute) $returnRoute.set(to);
});
